import { NextPage } from 'next'

import SignUpForm from 'components/auth/sign-up'
import { MetaTags } from '~shared'
import { Layout } from '~ui'

const JoinPage: NextPage = () => (
  <Layout>
    <MetaTags title="Join">
      <meta name="robots" content="noindex, nofollow" />
    </MetaTags>
    <Layout.Header />
    <Layout.Main withPadding withSidebar={false} backgroundColor="g-black">
      <SignUpForm />
    </Layout.Main>
  </Layout>
)

export default JoinPage
